import { BaseStoreData } from '../types/storeType'

export const svStoreInfo: BaseStoreData = {
  contactUrl: 'https://www.salmoiraghievigano.it/contattaci',
}
